/* ==========================================================================
   Lug Nut Torque Calculator
   Self-contained. Loaded only on this calculator's page.
   No shared dependencies.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-pc-ltc]');
  if (!root) return;

  /* Published ranges in foot-pounds. These are general figures. A vehicle
     specific value from the service manual always takes priority. */
  var SPEC = {
    m12x125: { name: 'M12 x 1.25', lo: 70,  hi: 80  },
    m12x15:  { name: 'M12 x 1.5',  lo: 80,  hi: 90  },
    m14x125: { name: 'M14 x 1.25', lo: 90,  hi: 105 },
    m14x15:  { name: 'M14 x 1.5',  lo: 100, hi: 120 },
    m14x20:  { name: 'M14 x 2.0',  lo: 110, hi: 130 },
    '716':   { name: '7/16 - 20',  lo: 70,  hi: 80  },
    '12':    { name: '1/2 - 20',   lo: 85,  hi: 95  },
    '916':   { name: '9/16 - 18',  lo: 120, hi: 135 },
    '58':    { name: '5/8 - 18',   lo: 140, hi: 160 }
  };

  var NM_PER_FTLB = 1.3558179483;
  var RETORQUE_MILES = 50;

  /* ====================================================================
     compute(input) -> result

     PURE. No DOM, no network, no globals. All calculator logic lives here
     so it can be reasoned about and tested in isolation.
     ==================================================================== */
  /* Star pattern: step around the circle by roughly half the lug count so
     each nut pulls the wheel down evenly rather than cocking it. */
  function pattern(n) {
    var step = n % 2 === 0 ? n / 2 : Math.floor(n / 2) + 1;
    if (step < 2) step = 2;
    var order = [], seen = {}, cur = 0;
    for (var i = 0; i < n; i++) {
      while (seen[cur]) cur = (cur + 1) % n;
      order.push(cur + 1);
      seen[cur] = true;
      cur = (cur + step) % n;
    }
    return order;
  }

  function compute(input) {
    var spec = SPEC[input.size];
    if (!spec) return { ok: false, errors: ['Pick a stud size.'] };
    var n = Math.round(input.lugs);
    if (!isFinite(n) || n < 3) return { ok: false, errors: ['Enter how many lugs per wheel.'] };

    var mid = (spec.lo + spec.hi) / 2;
    var order = pattern(n);

    var seatNote = input.seat === 'cone'
      ? 'Conical seats are the most common. The taper centres the nut as it tightens.'
      : (input.seat === 'ball'
         ? 'Ball seats are used by VW, Audi, Porsche, Honda and others. A conical nut in a ball seat contacts on a knife edge and works loose.'
         : 'Flat seat nuts rely on the washer to spread load. The washer must be free to turn against the nut.');

    var warnings = [];
    if (input.alloy) {
      warnings.push('Aftermarket alloys often need a re-torque after ' + RETORQUE_MILES + ' miles. The wheel settles against the hub as it heat cycles, and clamping load drops.');
    }

    return {
      ok: true, errors: [], warnings: warnings,
      status: { key: 'good', label: num(mid, 0) + ' ft-lb',
                note: 'Range ' + num(spec.lo, 0) + ' to ' + num(spec.hi, 0) + ' ft-lb. Always use a vehicle specific figure if you have one.' },
      figures: [
        { label: 'Torque', value: num(mid, 0) + ' ft-lb',
          sub: num(spec.lo, 0) + ' to ' + num(spec.hi, 0) + ' ft-lb, which is ' + num(spec.lo * NM_PER_FTLB, 0)
             + ' to ' + num(spec.hi * NM_PER_FTLB, 0) + ' Nm.' },
        { label: 'Tightening order', value: order.join(' - '),
          sub: 'Numbering the lugs clockwise from any point. Two passes, then a final check.' }
      ],
      rows: [
        { head: spec.name },
        { label: 'Low', value: num(spec.lo, 0) + ' ft-lb  (' + num(spec.lo * NM_PER_FTLB, 0) + ' Nm)' },
        { label: 'Midpoint', value: num(mid, 0) + ' ft-lb  (' + num(mid * NM_PER_FTLB, 0) + ' Nm)' },
        { label: 'High', value: num(spec.hi, 0) + ' ft-lb  (' + num(spec.hi * NM_PER_FTLB, 0) + ' Nm)' },
        { head: 'Method' },
        { label: 'Order', value: order.join(' - ') },
        { label: 'Passes', value: 'Snug all, then torque in two stages' },
        { label: 'Vehicle', value: 'On the ground, weight on the wheels' },
        { label: 'Re-torque after', value: RETORQUE_MILES + ' miles' },
        { head: 'Seat type' },
        { label: input.seat === 'cone' ? 'Conical' : (input.seat === 'ball' ? 'Ball' : 'Flat with washer'), value: 'Must match the wheel' }
      ]
    };
  }

  /* ====================================================================
     Formatting
     ==================================================================== */
  function comma(n) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function num(n, dp) {
    if (!isFinite(n)) return '-';
    var v = Number(n).toFixed(dp == null ? 2 : dp);
    if (dp !== 0 && v.indexOf('.') > -1) v = v.replace(/\.?0+$/, '');
    var parts = v.split('.');
    return comma(parts[0]) + (parts[1] ? '.' + parts[1] : '');
  }

  function signed(n, dp) {
    if (!isFinite(n)) return '-';
    return (n > 0 ? '+' : '') + num(n, dp);
  }

  /* ====================================================================
     DOM wiring
     ==================================================================== */
  var FIELDS = [
      {
          "name": "size",
          "key": "s",
          "type": "select"
      },
      {
          "name": "lugs",
          "key": "n",
          "type": "number"
      },
      {
          "name": "seat",
          "key": "t",
          "type": "select"
      },
      {
          "name": "alloy",
          "key": "a",
          "type": "checkbox"
      }
  ];

  var els = {
    error:    root.querySelector('[data-r-error]'),
    status:   root.querySelector('[data-r-status]'),
    statusLbl:root.querySelector('[data-r-status-label]'),
    statusVal:root.querySelector('[data-r-status-value]'),
    statusNote:root.querySelector('[data-r-status-note]'),
    figures:  root.querySelector('[data-r-figures]'),
    rows:     root.querySelector('[data-r-rows]'),
    warnings: root.querySelector('[data-r-warnings]')
  };

  var STATUS_CLASSES = ['is-good','is-monitor','is-soon','is-now','is-critical'];

  function field(name) { return root.querySelector('[data-f="' + name + '"]'); }

  function readInput() {
    var o = {};
    FIELDS.forEach(function (f) {
      var el = field(f.name);
      if (!el) return;
      if (f.type === 'checkbox') o[f.name] = el.checked;
      else if (f.type === 'number') o[f.name] = parseFloat(el.value);
      else o[f.name] = el.value;
    });
    return o;
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  }

  function renderFigures(figs) {
    els.figures.innerHTML = (figs || []).map(function (f) {
      return '<div class="pc-ltc__figure">'
        + '<div class="pc-ltc__figure-label">' + esc(f.label) + '</div>'
        + '<div class="pc-ltc__figure-value' + (f.muted ? ' is-muted' : '') + '">'
        + esc(f.value) + '</div>'
        + (f.sub ? '<div class="pc-ltc__figure-sub">' + esc(f.sub) + '</div>' : '')
        + '</div>';
    }).join('');
  }

  function renderRows(rows) {
    if (!els.rows) return;
    els.rows.innerHTML = (rows || []).map(function (r) {
      if (r.head) {
        return '<div class="pc-ltc__row pc-ltc__rows-head">' + esc(r.head) + '</div>';
      }
      return '<div class="pc-ltc__row">'
        + '<span class="pc-ltc__row-label">' + esc(r.label) + '</span>'
        + '<span class="pc-ltc__row-value">' + esc(r.value) + '</span>'
        + '</div>';
    }).join('');
  }

  function clearResult(message) {
    if (els.status) {
      STATUS_CLASSES.forEach(function (c) { els.status.classList.remove(c); });
      els.statusVal.textContent  = 'Waiting for your numbers';
      els.statusNote.textContent = message || '';
    }
    els.figures.innerHTML = '';
    if (els.rows) els.rows.innerHTML = '';
    if (els.warnings) els.warnings.style.display = 'none';
  }

  function render() {
    var input  = readInput();
    var result = compute(input);

    if (!result.ok) {
      els.error.textContent = result.errors[0];
      els.error.classList.add('is-shown');
      clearResult(result.errors[0]);
      return;
    }
    els.error.classList.remove('is-shown');

    if (els.status) {
      STATUS_CLASSES.forEach(function (c) { els.status.classList.remove(c); });
      if (result.status) {
        els.status.classList.add('is-' + result.status.key);
        els.statusVal.textContent  = result.status.label;
        els.statusNote.textContent = result.status.note || '';
      } else {
        els.statusVal.textContent  = '';
        els.statusNote.textContent = '';
      }
    }

    renderFigures(result.figures);
    renderRows(result.rows);

    if (els.warnings) {
      if (result.warnings && result.warnings.length) {
        els.warnings.textContent = result.warnings[0];
        els.warnings.style.display = '';
      } else {
        els.warnings.style.display = 'none';
      }
    }

    writePermalink(input);
  }

  /* ====================================================================
     Shareable result permalinks
     ==================================================================== */
  function writePermalink(input) {
    if (!window.history || !window.history.replaceState) return;
    var q = FIELDS.map(function (f) {
      var v = input[f.name];
      if (f.type === 'checkbox') return v ? f.key + '=1' : '';
      if (v == null || v !== v || v === '') return '';
      return f.key + '=' + encodeURIComponent(v);
    }).filter(Boolean).join('&');
    try {
      window.history.replaceState(null, '', window.location.pathname + (q ? '?' + q : ''));
    } catch (e) {}
  }

  function applyPermalink() {
    if (!window.URLSearchParams) return;
    var p = new URLSearchParams(window.location.search);
    var any = false;
    FIELDS.forEach(function (f) {
      if (!p.has(f.key)) return;
      var el = field(f.name);
      if (!el) return;
      if (f.type === 'checkbox') el.checked = p.get(f.key) === '1';
      else el.value = p.get(f.key);
      any = true;
    });
    return any;
  }

  /* ====================================================================
     Init
     ==================================================================== */
  ['input', 'change'].forEach(function (evt) {
    root.addEventListener(evt, function (e) {
      if (e.target.closest('[data-r-form]')) render();
    });
  });

  applyPermalink();
  render();

  /* Exposed for testing and debugging only. */
  window.PC_LTC = { compute: compute };
})();
